import styled, { css } from 'styled-components'

import { ReactComponent as Lockfile } from '../../assets/icons/lock.svg'

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 ${theme.spacing.stack.xxxl};
    padding-top: ${theme.spacing.stack.xxl};
    display: flex;
    justify-content: center;
    overflow-y: auto;
    @media (max-width: 1169px) {
      padding: ${theme.spacing.stack.xxs} ${theme.spacing.stack.xxs} 0
        ${theme.spacing.stack.xxs};
    }
  `}
`
export const Wrapper = styled.form`
  ${({ theme }) => css`
    width: 100%;
    height: max-content;
    max-width: 968px;
    display: flex;
    flex-direction: column;
    padding-bottom: ${theme.spacing.stack.xl};
    > button {
      margin-top: auto;
      margin-left: auto;
    }
    @media (max-width: 1169px) {
      padding-bottom: ${theme.spacing.stack.xxs};
    }
    .splitInput {
      display: flex;
      column-gap: 2rem;
      > div {
        width: 100%;
      }
      @media (max-width: 767px) {
        flex-direction: column;
      }
    }

    .district {
      width: 100%;
    }
    .twoInputs {
      display: flex;
      column-gap: 2rem;
      > div:last-child {
        width: 100%;
      }
      @media (max-width: 767px) {
        > div {
          width: 100%;
        }
        flex-direction: column;
      }
    }
    .complement {
      width: 100%;
    }
    .city {
      width: 100%;
    }
  `}
`

export const UpdatePasswordBox = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    display: flex;
    align-items: center;
    > p {
      color: ${theme.color.brand.primary.nth1};
    }
    margin-bottom: ${theme.spacing.stack.lg};
  `}
`

export const LockIcon = styled(Lockfile)`
  ${({ theme }) => css`
    fill: ${theme.color.brand.primary.nth1};
  `}
`

export const customStyles = {
  clearIndicator: () => ({
    border: '1px solid blue'
  }),
  control: (provided: any) => ({
    ...provided,
    display: 'flex',
    padding: '2px 16px',
    background: '#F4F4F4',
    outline: 'none',
    border: '1px solid transparent',
    boxShadow: 'none',
    borderColor: 'transparent',
    borderRadius: '6px',
    '&:focus-within': {
      borderColor: '#8601C9'
    }
  }),
  valueContainer: (provided: any) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  }),
  indicatorSeparator: (provided: any) => ({
    display: 'none'
  }),
  singleValue: (provided: any) => ({
    color: '#39383A',
    fontSize: '16px',
    lineHeight: '20px'
  }),
  placeholder: (provided: any) => ({
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A'
  }),
  menu: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A',
    borderRadius: '8px'
  }),
  menuList: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A',
    borderRadius: '8px'
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A',
    backgroundColor: state.isSelected ? '#F4F4F4' : 'white'
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A'
  })
}

export const Label = styled.p`
  ${({ theme }) => css`
    color: #39383a;
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.regular};
    line-height: 24px;
    margin-bottom: 2px;
  `}
`

export const Error = styled.p`
  ${({ theme }) => css`
    color: #fc3e3e;
    font-size: ${theme.font.size.xxs};
    min-height: ${theme.spacing.stack.xxs};
  `}
`
